// extracted by mini-css-extract-plugin
export default {"row":"statsBar_row__aUTL9","counter":"statsBar_counter__3JvY2","label":"statsBar_label__8-Ysl"};